import { Link } from 'react-router-dom';
import SectionTitle from '@/components/base/SectionTitle';
import { topicSpots } from '@/mocks/site';

export default function TopicSpots() {
  return (
    <section className="mt-10 bg-background-200/60 py-10 md:mt-14 md:py-14">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <SectionTitle title="主题专题推荐" subtitle="聚合热点 · 深度呈现" icon="ri-bookmark-3-line" />
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          {topicSpots.map((topic) => (
            <Link
              key={topic.id}
              to={topic.link}
              className="group relative h-56 overflow-hidden rounded-xl md:h-64"
            >
              <img
                src={topic.image}
                alt={topic.title}
                title={topic.title}
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/90 via-secondary-950/40 to-transparent"></div>
              <div className="relative flex h-full flex-col justify-end p-5">
                <span className="inline-flex w-fit items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-[11px] font-medium text-background-50">
                  {topic.label}
                </span>
                <h3 className="mt-2.5 line-clamp-2 font-heading text-lg font-bold text-background-50">{topic.title}</h3>
                <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-background-300">{topic.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}